import React from 'react';
import { Link } from '../../visions/vx-link';
import flyerPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/compressedupdatedglobalrecallsflyer.compressed.pdf';

const AboutPortal = (props) => (
	<div className="container main">
		<h2>Acerca del Portal</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<iframe width="100%" height="310" src="https://player.vimeo.com/video/170923073" frameBorder="0" allowFullScreen=""/>
			</div>
			<div className="col-sm-6">
				<h4>¿En qué consiste el <em>Portal Global de Alertas</em> de retirada de productos?</h4>
				<p>
					El <em>Portal Global de Alertas</em> permite acceder a toda la información, actualizada periódicamente, sobre la retirada de productos del mercado, en todos los rincones del globo,
					desde un único punto: una plataforma OCDE. El Portal Global de Alertas contiene información sobre las retiradas obligatorias y voluntarias de productos de consumo
					efectuadas —o notificadas— y dadas a conocer públicamente por los distintos organismos gubernamentales competentes. El alcance y ámbito de dichas alertas de retirada varían
					en función de las competencias de las autoridades gubernamentales concretas de las que proceda la información. En algunos casos, se incluye la retirada de productos alimentarios, automóviles, productos farmacéuticos y medicamentos.
				</p>
				<p>La presentación oficial del Portal Global de Alertas tuvo lugar el 19 de octubre de 2012.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>¿A quién va dirigido el Portal?</h4>
				<p>
					El <em>Portal Global de Alertas</em> facilita el intercambio de información entre jurisdicciones y simplifica la tarea de las autoridades de vigilancia para poder adoptar medidas correctoras.
					Se invita a todas las jurisdicciones que cuenten con su propia base de datos de retirada de productos electrónicos que participen en el Portal.
				</p>
				<p>
					El Portal también es una herramienta útil para consumidores y empresas. Por un lado, los consumidores pueden acceder al Portal para comprobar si existen problemas de seguridad asociados
					a los productos que deseen adquirir, lo que resulta especialmente útil a la hora de realizar compras transfronterizas en línea. Por otro, las empresas pueden optimizar la detección
					de riesgos emergentes a escala mundial, circunstancia que les permitirá actuar con rapidez para abordar eventuales problemas en sus propios productos.
				</p>
				<p>El Portal es una fuente de información especialmente valiosa para organismos reguladores, consumidores y empresas de países que no disponen de su propia base de datos de retirada de productos de consumo en línea.</p>
			</div>
			<div className="col-sm-6">
				<h4>¿Qué retiradas de productos contiene el Portal?</h4>
				<p>
					En la actualidad, el <em>Portal Global de Alertas</em> ofrece información sobre la retirada de productos de consumo de 47 jurisdicciones en todo el mundo e incorpora la información de los
					portales de alertas regionales de la Unión Europea y la Asociación de Naciones del Asia Sudoriental (ASEAN). Se actualiza periódicamente para incluir datos nuevos y datos históricos de las jurisdicciones participantes.
				</p>
				<p>
					Pueden existir pequeñas diferencias de una jurisdicción participante a otra en lo concerniente al tipo de productos que designa la expresión «productos de consumo». Por ejemplo,
					en algunos países se incluyen y ordena la retirada de productos cosméticos bajo esta categoría, mientras que en otros se clasifica como tales a los automóviles.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>¿Cómo se actualiza el Portal?</h4>
				<p>
					Cada jurisdicción decide con qué frecuencia y en qué momento realiza la transmisión de datos al Portal, que podrá hacerlo de forma automática o manual, en función de sus propios sistemas.
					De este modo, las actualizaciones pueden tener una periodicidad diaria, semanal o mensual.
				</p>
			</div>
			<div className="col-sm-6">
				<h4>¿Durante cuánto tiempo aparecen las alertas de retirada de productos en el Portal?</h4>
				<p>La información quedará almacenada en el Portal mientras lo autorice cada jurisdicción concernida, por lo que existe la posibilidad de que ciertos datos permanezcan disponibles con carácter indefinido.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>¿Podría la información sobre la retirada de un producto figurar en el Portal y no en la página web correspondiente de la jurisdicción competente o viceversa?</h4>
				<p>
					Cada jurisdicción participante decide qué información comparte a través del Portal. De ahí, la posibilidad de que una jurisdicción disponga de una mayor información sobre la retirada
					de un determinado producto en su propio sitio web.
				</p>
				<p>No obstante, lo habitual es que las jurisdicciones participantes compartan toda información públicamente accesible sobre la retirada de productos a través del Portal.</p>
			</div>
		</div>
	</div>
);

export default AboutPortal;



// WEBPACK FOOTER //
// ./src/views/static/es/about-portal.js